import { render, staticRenderFns } from "./EventRow.vue?vue&type=template&id=1c49e5e5&"
import script from "./EventRow.vue?vue&type=script&lang=js&"
export * from "./EventRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports